import { I18n } from "@aws-amplify/core";
import { translations, useAuthenticator } from "@aws-amplify/ui-react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Auth } from 'aws-amplify';
import React, { useRef } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { theme } from "./branding";
import LandingPage from "./components/LandingPage/LandingPage";
import i18nStrings from "./i18n/i18n";
import { getCurrentTOS } from "./common/service";
import { setLang, setUser, setTOS } from "./redux/actions";
const config = require("Config");


I18n.putVocabularies(translations);
I18n.putVocabularies(i18nStrings);
I18n.putVocabulariesForLanguage('en', {
	'PreTokenGeneration failed with error Service not available now. Please try after some time!.': 'Our service is temporarily unavailable. Please try again later.',
	'UsernameExistsException: An account with the given email already exists.': 'Email has already been taken. You can sign in, or reset your password.',
	'Sign in': 'Login with email',
	'Create Account': 'Sign up with email',
	"Your passwords must match": "Passwords doesn't match",
	'UserLambdaValidationException: Email id already exists.': 'Email has already been taken. You can sign in, or reset your password.'
});

const loadDefaultLanguage = () => {
	const navLang = navigator.language.substr(0, 2);

	if (i18nStrings.hasOwnProperty(navLang)) return navLang;

	return "en";
};

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
		user: state.app.user,
	};
};

const App = (props) => {

	const initialAuthState = useRef("");
	const [reRender, setReRender] = React.useState(null);
	const [provider, setProvider] = React.useState('cognito');
	const { authStatus, route } = useAuthenticator((context) => [
		context.route,
		context.signOut,
		context.authStatus,
	]);
	// console.log(route + " - " + authStatus);
	props.setLang(loadDefaultLanguage());
	I18n.setLanguage(loadDefaultLanguage());
	props.setLang(loadDefaultLanguage());
	const location = useLocation();
	const navigate = useNavigate();

	let queryStringParams = new URLSearchParams(
		decodeURIComponent(window.location.search)
	);

	let isVerificationTokenFound = false;
	if (queryStringParams.get("token") && window.location.href.includes("confirmPassword") === false) {
		sessionStorage.setItem("activationToken", queryStringParams.get("token"));
		isVerificationTokenFound = true;
	}
	else if (location.pathname === "/sign_up" && sessionStorage.getItem("inviteCode") && authStatus == "authenticated" && props.user) {
		sessionStorage.setItem("redirectUrl", `/sign-up?inviteCode=${sessionStorage.getItem("inviteCode")}`);
		localStorage.removeItem('redirectInfo');
		navigate("/logout");
	}

	React.useEffect(() => {
		const getTos = async () => {
			try {
				let resp = await getCurrentTOS();
				if (resp?._id)
					props.setTOS(resp);
			} catch (error) {
				props.setTOS({ _id: "" });
			}
		}
		if (!props.tos && config.enableGusIntegration) {
			getTos();
		}
	}, []);

	React.useEffect(() => {
		if (initialAuthState.current === "resetPassword" && route === "signIn") {
			navigate("/" + location.search);
		}
	}, [route]);

	React.useEffect(() => {
		if (location.pathname === "/sign_up") {
			let fn = async () => {
				if (props.user) {
					try {
						if (isVerificationTokenFound)
							sessionStorage.setItem(
								"redirectUrl",
								`/sign-up?token='${queryStringParams.get("token")}`
							);
						else sessionStorage.setItem("redirectUrl", `/sign-up`);
						navigate("/logout" + location.search);
						return;
					} catch (e) {
						console.log("No user logged in");
					}
				}
			};
			fn();
		}
	}, [authStatus]);

	React.useEffect(() => {
		const callback = async () => {
			if (queryStringParams.get("initialAuthState") === "signIn" || queryStringParams.get("initialAuthState") === "signUp") {
				initialAuthState.current = queryStringParams.get("initialAuthState");
			} else if ((location.pathname === "/sign-up" || location.pathname === "/sign_up") && initialAuthState.current === "") {
				initialAuthState.current = "signUp";
			} else if (location.pathname === "/resetPassword") {
				initialAuthState.current = "resetPassword";
				if (props.user) {
					sessionStorage.setItem("isResetPasswordFlow", true)
					await Auth.signOut();
					window.location = "/resetPassword";
				}
			} else if (location.pathname === "/changePassword" && props.user) {
				if (props.user.attributes?.identities && props.user.attributes?.identities?.length > 0) {
					let identities = JSON.parse(props.user.attributes.identities);
					if (identities && identities.length > 0)
						setProvider(identities[0].providerName);
				}
				initialAuthState.current = "changePassword";
				setReRender(true);
			}
		}
		callback();
	}, [props.user, location.pathname])

	return (
		<div>
			<MuiThemeProvider theme={theme}>
				<LandingPage
					initialAuthState={initialAuthState.current}
					authStatus={authStatus}
					provider={provider}
					route={route}
				/>
			</MuiThemeProvider>
		</div>
	);
};

export default connect(mapStateToProps, { setLang, setUser, setTOS })(App);
